import React from 'react';

const Modal = ({ isOpen, onClose, title, message, type = 'info', onConfirm = null, confirmText = 'OK', cancelText = 'Cancel', onGoToCart = null, onContinueShopping = null }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getModalTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          iconColor: '#22c55e',
          icon: '✅',
          borderColor: '#22c55e'
        };
      case 'error':
        return {
          iconColor: '#ef4444',
          icon: '❌',
          borderColor: '#ef4444'
        };
      case 'warning':
        return {
          iconColor: '#f59e0b',
          icon: '⚠️',
          borderColor: '#f59e0b'
        };
      case 'confirm':
        return {
          iconColor: '#3b82f6',
          icon: '❓',
          borderColor: '#3b82f6'
        };
      default:
        return {
          iconColor: '#6366f1',
          icon: 'ℹ️',
          borderColor: '#6366f1'
        };
    }
  };

  const styles = getModalTypeStyles();

  return (
    <div className="modal-overlay" onClick={handleBackdropClick}>
      <div className="modal-container">
        <div className="modal-header">
          <div className="modal-icon" style={{ color: styles.iconColor }}>
            {styles.icon}
          </div>
          <h3 className="modal-title">{title}</h3>
        </div>
        
        <div className="modal-body">
          <p className="modal-message" style={{ whiteSpace: 'pre-line' }}>{message}</p>
        </div>
        
        <div className="modal-footer">
          {type === 'confirm' ? (
            <>
              <button 
                className="modal-btn modal-btn-secondary" 
                onClick={onClose}
              >
                {cancelText}
              </button>
              <button 
                className="modal-btn modal-btn-primary" 
                onClick={handleConfirm}
                style={{ backgroundColor: styles.borderColor }}
              >
                {confirmText}
              </button>
            </>
          ) : type === 'cart-success' ? (
            <>
              <button 
                className="modal-btn modal-btn-secondary" 
                onClick={() => {
                  onContinueShopping && onContinueShopping();
                  onClose();
                }}
              >
                Continue Shopping
              </button>
              <button 
                className="modal-btn modal-btn-primary" 
                onClick={() => {
                  onGoToCart && onGoToCart();
                  onClose();
                }}
                style={{ backgroundColor: styles.borderColor }}
              >
                Go to Cart
              </button>
            </>
          ) : (
            <button 
              className="modal-btn modal-btn-primary" 
              onClick={onClose}
              style={{ backgroundColor: styles.borderColor }}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          backdrop-filter: blur(4px);
        }

        .modal-container {
          background: white;
          border-radius: 20px;
          padding: 0;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
          transform: scale(1);
          animation: modalAppear 0.3s ease-out;
          border-top: 4px solid ${styles.borderColor};
        }

        @keyframes modalAppear {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .modal-header {
          padding: 25px 25px 15px;
          text-align: center;
          border-bottom: 1px solid #f1f5f9;
        }

        .modal-icon {
          font-size: 3rem;
          margin-bottom: 10px;
        }

        .modal-title {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 600;
          color: #1e293b;
        }

        .modal-body {
          padding: 20px 25px;
          text-align: center;
        }

        .modal-message {
          margin: 0;
          color: #64748b;
          font-size: 1rem;
          line-height: 1.6;
        }

        .modal-footer {
          padding: 15px 25px 25px;
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .modal-btn {
          padding: 12px 24px;
          border: none;
          border-radius: 12px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 100px;
        }

        .modal-btn-primary {
          background-color: ${styles.borderColor};
          color: white;
        }

        .modal-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .modal-btn-secondary {
          background-color: #f8fafc;
          color: #64748b;
          border: 1px solid #e2e8f0;
        }

        .modal-btn-secondary:hover {
          background-color: #f1f5f9;
          transform: translateY(-1px);
        }
      `}</style>
    </div>
  );
};

export default Modal; 